import React from "react";
import classNames from "classnames";

const InputField = ({
  label,
  id,
  type = "text",
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  serverError,
  disabled = false,
  size = "sm",
  ...props
}) => {
  const sizeClasses = classNames({
    "px-3 py-2 text-[12px]": size === "sm",
    "px-4 py-3 text-sm": size === "md",
    "px-5 py-4 text-base": size === "lg",
  });

  const inputClasses = classNames(
    "w-full border rounded-lg transition-all duration-300",
    sizeClasses,
    {
      "border-gray-300": !error && !serverError && !disabled,
      "focus:border-primary-500": !error && !serverError && !disabled,
      "border-red-500": (error || serverError) && !props.focused,
      "bg-gray-100 cursor-not-allowed": disabled,
    }
  );

  const errorClasses = classNames("text-[12px] text-red-500 mt-1", {
    "ml-2": true,
  });
  return (
    <div>
      {label && (
        <label
          htmlFor={id}
          className="block mb-1 ml-1 text-sm font-medium text-gray-700"
        >
          {label}
        </label>
      )}
      <div className="relative">
        <input
          id={id}
          name={id}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={!placeholder ? `Enter ${label}` : placeholder}
          className={inputClasses}
          {...props}
        />
        {(error || serverError) && (
          <div className={errorClasses}>{error || serverError}</div>
        )}
      </div>
    </div>
  );
};

export default InputField;
